export default __webpack_public_path__ + "businessBuilding.8d0e1da.png";